export default {"src":"/_next/static/media/brand-selected-calendar.8eead019.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};